export const environment = {
  version: '2.0.3',
  ENVIRONMENT: 'production',
  production: true,
  apiUrl: window["env"]["apiUrl"] || "https://epaxtest.northeurope.cloudapp.azure.com/uiapi/",
  authMode: null,
  azureCredentials: {
    clientIdUi: 'c7ca450d-20f8-4570-9546-98479918b669',
    tenantId: 'b96bf294-627c-4c88-9a24-b6c6ec7e634c',
    redirectUri: 'https://epaxtest.northeurope.cloudapp.azure.com',
    clientIdApi: '7d969681-fbe8-4cb3-8c1d-3c7d1090be2a',
    scopeName: 'default'
  }
};
